import { render, staticRenderFns } from "./HeatmapTableColumnsDrawer.vue?vue&type=template&id=70cee0ef&scoped=true"
import script from "./HeatmapTableColumnsDrawer.vue?vue&type=script&lang=ts"
export * from "./HeatmapTableColumnsDrawer.vue?vue&type=script&lang=ts"
import style0 from "./HeatmapTableColumnsDrawer.vue?vue&type=style&index=0&id=70cee0ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cee0ef",
  null
  
)

export default component.exports